import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import "./style.scss";
import Logo from "../../assets/imgs/logoTheaccounter.svg";
import HomeImg from "../../assets/imgs/home-beta.svg";
import AddDocumentIcon from "../../assets/imgs/icons/add-document.svg";
import LogoutIcon from "../../assets/imgs/icons/logout.svg";
import EditIcon from "../../assets/imgs/icons/edit.svg";
import DropDownIcon from "../../assets/imgs/icons/arrow_drop_down.svg";
import AddIcon from "../../assets/imgs/icons/add-2.svg";
import SwitchCompany from "../../components/SwitchCompany";
import Auth from "../../services/Auth";
import useModal from "../../components/Modal/useModal";
import ConfirmLogout from "../../components/Modal/ConfirmLogout";
import { generateAvatar } from "../../utils";
const Home = ({ user, currentCompany }) => {
  const callPromptModalConfrimLogout = useModal(ConfirmLogout);
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const ref = useRef(null);
  const profileRef = useRef(null);
  const navigator = useNavigate();

  const toggleOpen = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const toggleProfileOpen = () => {
    setIsProfileOpen((isProfileOpen) => !isProfileOpen);
  };

  const onClickOutside = () => {
    setIsOpen(false);
  };

  const onClickOutsideProfile = () => {
    setIsProfileOpen(false);
  };
  const logout = async () => {
    try {
      const res = await callPromptModalConfrimLogout({
        title: "Log out?",
        message: "Are you sure you want to log out?",
      });
      if (res) {
        await Auth.logout();
        navigator("/login");
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        onClickOutside && onClickOutsideProfile();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [profileRef]);
  const avatar = generateAvatar(user?.name);

  return (
    <div class="container-center-horizontal">
      <div class="home-page-beta screen">
        <div class="header">
          <img class="logo" src={Logo} />
          <div class="left">
            <div class="text">
              <div class="company roboto-normal-rolling-stone-14px-2">
                Company
              </div>
              <SwitchCompany />
            </div>
          </div>
          <div class="right">
            <div class="relative" ref={ref}>
              <div class="button" onClick={toggleOpen}>
                <img class="add-2" src={AddIcon} />
                <div class="button-1 roboto-bold-white-14px">Create</div>
              </div>
              {isOpen && (
                <div
                  class="absolute py-2 bg-white rounded-md shadow-dropdownMenu overflow-hidden z-20 mt-4"
                  style={{ marginLeft: "-40px" }}
                >
                  <div class="dropdown-menu-add-a-new-orderscreen">
                    <div
                      class="list-group-item"
                      onClick={() => {
                        navigator("/new-request/upload");
                      }}
                    >
                      <img class="add-document" src={AddDocumentIcon} />
                      <div class="text valign-text-middle roboto-medium-outer-space-14px">
                        Upload Document
                      </div>
                    </div>
                    <div
                      class="list-group-item-1"
                      onClick={() => {
                        navigator("/new-request/create-payment");
                      }}
                    >
                      <img class="edit" src={EditIcon} />
                      <div class="text valign-text-middle roboto-medium-outer-space-14px">
                        Create Document
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div class="relative" ref={profileRef}>
              <div class="profile" onClick={toggleProfileOpen}>
                <div class="avatar">
                  <div class="mj valign-text-middle roboto-bold-pacific-blue-16px">
                    {avatar}
                  </div>
                </div>
                <div class="name valign-text-middle roboto-medium-outer-space-16px">
                  {user?.name}
                </div>
                <img class="arrow-drop-down" src={DropDownIcon} />
              </div>

              {isProfileOpen && (
                <div class="absolute bg-white rounded-md shadow-dropdownMenu overflow-hidden z-20 profile-menu w-auto">
                  <div class="w-full h-full border-1px-outer-space-2">
                    <div class="dropdown-menu-user-menu-1 border-1px-outer-space-2 px-4">
                      <div class="list-group-itemdefault w-max">
                        <div class="avatar">
                          <div class="mj valign-text-middle">{avatar}</div>
                        </div>
                        <div class="flex-col-profile w-max">
                          <div class="nameProfile">{user?.name}</div>
                          <div class="yourmailcom">
                            {user.email || user.mobile}
                          </div>
                        </div>
                      </div>
                      <div
                        class="list-group-itemdefault-1 w-max"
                        onClick={logout}
                      >
                        <div class="sign-out">
                          <img src={LogoutIcon} alt="" />
                        </div>
                        <div class="text valign-text-middle">Log out</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="cards">
          <div class="flex-row">
            <div class="flex-col">
              <div class="badgebase">
                <div class="badge valign-text-middle roboto-bold-white-14px">
                  BETA 1.0
                </div>
              </div>
              <h1 class="welcome-to-the-first poppins-bold-outer-space-24px">
                Welcome to the first beta edition of The Accounter web-version.
              </h1>
              <p class="here-to-change-the-w roboto-medium-outer-space-14px">
                Here to change the world of Accounting for SMEs.
                <br />
                This is not our final form, many more amazing features are under
                preparation and will be added to this page very soon.
                <br />
                Enjoy simple accounting made easy. Start uploading now.
              </p>
              <div class="buttons">
                <div
                  class="button-2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigator("/new-request/upload");
                  }}
                >
                  <div class="button-3 roboto-bold-white-14px">
                    Upload Document
                  </div>
                </div>
                <div
                  class="button-4 border-1px-pacific-blue"
                  onClick={(e) => {
                    e.preventDefault();
                    navigator("/new-request/create-payment");
                  }}
                >
                  <div class="button-5 roboto-bold-pacific-blue-14px">
                    Create Document
                  </div>
                </div>
              </div>
            </div>
            <div class="overlap-group">
              <img src={HomeImg} />
            </div>
          </div>
          <p class="if-you-have-any-ques">
            <span class="roboto-normal-outer-space-14px">
              If you have any questions or need help, contact our
            </span>
            <span class="span1">&nbsp;</span>
            <a
              href={`mailto:customersupport@theaccounter.com?subject=${
                user.name
              }%20is%20facing%20an%20issue%20on%20Theaccounter%20web%20app%20-%20(${
                user.email || user.mobile
              })&body=User%20Name%3A%20${user.name}%0D%0AUser%20Contact%3A%20${
                user.email || user.mobile
              }%0D%0ACompany%20Name%3A%20${
                currentCompany.name
              }%0D%0A%0D%0AStart%20describing%20your%20issue%20here`}
              target="_blank"
            >
              <span class="span2">support team</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser,
    currentCompany: state.Company.currentCompany,
  };
};

export default connect(mapStateToProps, {})(Home);
